import 'zone.js';
import { publishFacade } from '@angular/compiler';

// Proveer compilador JIT global para fallback en runtime
try {
  publishFacade(globalThis);
} catch (e) {
  console.warn('Could not initialize compiler facade in polyfills:', e);
}
